import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

export const ApiBaseUrl = process.env.VUE_APP_API_URL;
// custom options
export const AXIOS_DEFAULT_OPTIONS = {
  isLoading: true, // show loading
  isErrMsg: true, // show err msg
  isErrToast: false,
  isApiHost: true, // prefix api url
  isApiMock: false, // prefix /api/mock to mock data
  isRemoveField: true, // remove all empty params
  removeFields: [], // manual remove empty params
};

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    Vue.axios.defaults.withCredentials = true;
  },

  request(config) {
    return Vue.axios.request(config);
  },
  query(resource, config = {}) {
    const opts = { ...AXIOS_DEFAULT_OPTIONS, ...config };
    return Vue.axios.get(resource, opts).catch(error => {
      throw new Error(`ApiService ${error}`);
    });
  },

  get(resource, slug = '') {
    return Vue.axios.get(`${resource}/${slug}`).catch(error => {
      throw new Error(`ApiService ${error}`);
    });
  },

  post(resource, params, config = {}) {
    const opts = { ...AXIOS_DEFAULT_OPTIONS, ...config };
    return Vue.axios.post(`${resource}`, params, opts);
  },

  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  put(resource, params, config = {}) {
    const opts = { ...AXIOS_DEFAULT_OPTIONS, ...config };
    return Vue.axios.put(`${resource}`, params, opts);
  },

  delete(resource, params) {
    return Vue.axios.delete(resource, { data: params }).catch(error => {
      throw new Error(`ApiService ${error}`);
    });
  },
  file(resource, params) {
    return Vue.axios({
      method: 'GET',
      url: resource,
      params,
      responseType: 'blob',
    }).catch(error => {
      throw new Error(`ApiService ${error}`);
    });
  },
  multiPost(resource, payload) {
    return Vue.axios.request({
      headers: { 'Content-Type': 'multipart/form-data' },
      method: 'POST',
      url: resource,
      responseType: 'json',
      data: payload,
    });
  },
  multiPut(resource, payload) {
    return Vue.axios.request({
      headers: { 'Content-Type': 'multipart/form-data' },
      method: 'PUT',
      url: resource,
      responseType: 'json',
      data: payload,
    });
  },
};
export default ApiService;
